import { useEffect, useEffectEvent } from 'react';

import { gestureThrottle } from '@/lib/gestureThrottle';

export const useSectionScroll = (handler: (direction: 'up' | 'down') => void, disabled?: boolean) => {
  const handleScroll = useEffectEvent((accumulatedDelta: number) => {
    const isScrollingDown = accumulatedDelta > 0;

    if (isScrollingDown) {
      handler('up');
      return;
    }

    handler('down');
  });

  useEffect(() => {
    if (disabled) {
      return;
    }

    const throttledWheel = gestureThrottle(handleScroll);

    const wheelHandler = (event: WheelEvent) => {
      throttledWheel(event.deltaY);
    };

    window.addEventListener('wheel', wheelHandler, { passive: true });

    return () => {
      window.removeEventListener('wheel', wheelHandler);
    };
  }, [disabled]);

  useEffect(() => {
    if (disabled) {
      return;
    }

    const throttledTouch = gestureThrottle(handleScroll);

    let touchStartY = 0;

    const touchStartHandler = (event: TouchEvent) => {
      touchStartY = event.touches[0].clientY;
    };

    const touchMoveHandler = (event: TouchEvent) => {
      const touchEndY = event.touches[0].clientY;
      const deltaY = touchStartY - touchEndY;

      if (Math.abs(deltaY) > 50) {
        throttledTouch(deltaY);
        touchStartY = touchEndY;
      }
    };

    window.addEventListener('touchstart', touchStartHandler, { passive: true });
    window.addEventListener('touchmove', touchMoveHandler, { passive: true });

    return () => {
      window.removeEventListener('touchstart', touchStartHandler);
      window.removeEventListener('touchmove', touchMoveHandler);
    };
  }, [disabled]);
};
